import { Component, AfterViewInit } from '@angular/core';

@Component({
    selector: '[app-service-report]',
    templateUrl: './service-report.component.html',
    styleUrls: ['./service-report.component.css'],
    standalone: false
})
export class ServiceTasksReportComponent implements AfterViewInit {
  ngAfterViewInit() {
      window.dispatchEvent(new CustomEvent("ComponentLoad", { detail: "ServiceTasksReport" }));
  }
}
